import type { CareersLocationModelType, ICareersLocationPage } from "../types";

export const allUnitedStatesKey = "AllUS";

export const normalizeCareersLocationValue = (value: string | undefined): string => value?.trim().toLowerCase() ?? "";

export const getCareersLocationKey = (country: string | undefined, state: string | undefined): string => {
  const normalizedCountry = normalizeCareersLocationValue(country);
  const normalizedState = normalizeCareersLocationValue(state);

  if (
    normalizedCountry === "united states" &&
    normalizedState &&
    normalizedState !== normalizeCareersLocationValue(allUnitedStatesKey)
  ) {
    return `${normalizedCountry}|${normalizedState}`;
  }

  return normalizedCountry;
};

export const isCareersLocationVisible = (page: ICareersLocationPage): boolean => page.isVisibleOnWebsite === true;

export const createCareersLocationModel = (
  page: ICareersLocationPage,
  permalink: string,
): CareersLocationModelType | undefined => {
  if (!page.country || !page.contentLink?.id || !permalink || !isCareersLocationVisible(page)) {
    return undefined;
  }

  return {
    page,
    country: page.country,
    state: page.state ?? "",
    key: getCareersLocationKey(page.country, page.state),
    label: page.name,
    permalink,
    navigationOrder: page.navigationOrder ?? 1000,
  };
};
